export const productTypeValues = [
  'prebidStack',
  'priceGenius',
  'refresher',
  'richPlacements',
  'unfilledRecovery',
  'viewabilityTools',
] as const

export type Product = (typeof productTypeValues)[number]
